export default __webpack_public_path__ + "static/media/impactImg.db682e5f.png";